/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Cpe
 */
export interface Cpe {
}

/**
 * Check if a given object implements the Cpe interface.
 */
export function instanceOfCpe(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CpeFromJSON(json: any): Cpe {
    return CpeFromJSONTyped(json, false);
}

export function CpeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Cpe {
    return json;
}

export function CpeToJSON(value?: Cpe | null): any {
    return value;
}

